import { render, staticRenderFns } from "./RecommenderGrid.vue?vue&type=template&id=fdd741ae&"
import script from "./RecommenderGrid.vue?vue&type=script&lang=js&"
export * from "./RecommenderGrid.vue?vue&type=script&lang=js&"
import style0 from "./RecommenderGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RecommenderGrid.vue"
export default component.exports